import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";
import { HttpClient } from '@angular/common/http';

@Component({
  templateUrl: "./possible-resolution-dialog.template.pug",
  providers: [
    
  ],
})
export class PossibleResolutionDialogComponent extends DialogComponent<void, boolean> {
  public error: Error;
  
  possibleResolutionUrl = "/possibleResolution.md";
  public data: any;
  static errorData = {};
  public fileCOntent;
  public finalError;
  private parser = '### ';
  static showCreateDialog(dialogService: DialogService,data:any): Observable<boolean> {
    this.errorData = data;
    
    return dialogService.addDialog(PossibleResolutionDialogComponent, undefined, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }



 

  cancel(): void {
    this.result = false;
    this.close();
  }

  async ngOnInit() {
    this.data = PossibleResolutionDialogComponent.errorData;
    
    this.possibleResolutionUrl = await this.readDataFromFile(this.possibleResolutionUrl,this.data)
  }

  async readDataFromFile(file,errorData){
    this.fileCOntent = await this.http.get(`${file}`, { responseType: 'text'}).toPromise();
    if(typeof errorData === 'string'){
      errorData = JSON.parse(errorData);
    }
    return this.getErrorByCode(this.fileCOntent.split(this.parser),errorData.errorCode)
  }

  getErrorByCode(contents,errorCode){
    let errorContent = '';
    for (let i = 0; i < contents.length; i++) {
      if (contents[i].includes(errorCode)){
        errorContent =  `${this.parser}${contents[i]}`.replace(`${this.parser}${errorCode}`,'');
        break;
      }
    }
    return errorContent ? errorContent : '**Sorry, We are not able to find possible resolution**';
  }
  constructor(
    public dialogService: DialogService,
    public http:HttpClient
    
  ) {
    super(dialogService);
  }
}
